import axios from "./axios";

const testApi = () => axios.get("/demo/test1")
//获取系统基础配置
const getSystemBasicsInfo = () => axios.get("/system/getSystemBasicsInfo")
const emailCodeSend = (params) => axios.post("/ems/send", params)
//用户邮箱注册
const emailRegister = (params) => axios.post("/user/emailRegister", params)
//用户邮箱登录
const emailLogin = (params) => axios.post("/user/emailLogin", params)
//个人中心登录密码重置
const resetPwd = (params) => axios.post("/user/resetpwd", params)
//用户忘记密码
const forgetPwd = (params) => axios.post("/user/forgetPwd", params)
//修改用户支付密码
const resetPayPwd = (params) => axios.post("/user/resetPayPwd", params)
//修改用户登录密码
const resetLoginPwd = (params) => axios.post("/user/resetLoginPwd", params)
//用户退出登录
const logout = (params) => axios.post("/user/logout", params)
//轮播图
const bannerList = (params) => axios.post("/system/getBannerList", params)
//获取用户信息
const getUserInfo = (params) => axios.post("/user/userInfo", params)
//获取用户面板的统计数据
const getUserStatistics = (params) => axios.post("/user/getUserDashboardStatistics", params)
//获取用户近一周的充值记录
const depositLog = (params) => axios.post("/wallet/userRechargeLog", params)
//获取用户近一周的提现记录
const withdrawLog = (params) => axios.post("/wallet/userWithdrawLog", params)
//获取支付方式
const paymentList = (params) => axios.post("/system/getPaymentList", params)
//获取交易（收益）记录
const transactionsLog = (params) => axios.post("/wallet/transactionsLog", params)
//获取订单列表
const orderList = (params) => axios.post("/products/userProductsList", params)
//获取订单详情
const orderDetail = (params) => axios.post("/products/userProductsDetail", params)
//获取邀请记录（下级）
const referralsLog = (params) => axios.post("/user/referralsLog", params)
//获取前台模块内容信息
const frontModuleList = (params) => axios.post("/system/frontModuleList", params)
//获取产品列表
const productsList = (params) => axios.post("/products/productsList", params)
//获取产品详情
const productDetail = (params) => axios.post("/products/productsDetail", params)
//购买产品
const productsBuy = (params) => axios.post("/products/productsBuy", params)
//获取文章列表
const articlesList = (params) => axios.post("/system/articlesList", params)
//获取文章详情
const articlesDetail = (params) => axios.post("/system/articlesDetail", params)
//获取多语言列表
const langList = (params) => axios.post("/index/lang", params)
//用户充值
const userRecharge = (params) => axios.post("/wallet/userRecharge", params)
//用户充值凭证上传接口
const userRechargeUpload = (params) => axios.post("/wallet/userRechargeUpload", params)
//用户查看充值详情
const userRechargeDetail = (params) => axios.post("/wallet/userRechargeDetail", params)
//获取提现方式列表
const withdrawalMethodList = (params) => axios.post("/system/getWithdrawalMethodList", params)

//获取提现方式列表
const userWithdraw = (params) => axios.post("/wallet/userWithdraw", params)

//用户邀请记录
const inviteList = (params) => axios.post("/invite/inviteList", params)

//用户工单列表
const getFeedbackList = (params) => axios.post("/feedback/getFeedbackList", params)

//创建工单
const setFeedback = (params) => axios.post("/feedback/setFeedback", params)

//工单详情
const getFeedbackDetail = (params) => axios.post("/feedback/getFeedbackDetail", params)

//获取用户绑定谷歌验证器链接
const googleAuth = (params) => axios.post("/system/googleAuth", params)

//校验谷歌code
const verifyGoogleAuthCode = (params) => axios.post("/system/verifyGoogleAuthCode", params)

//更新用户钱包地址
const setWithdrawAddress = (params) => axios.post("/wallet/setWithdrawAddress", params)

//汇率换算接口
const currencyConversion = (params) => axios.post("/index/currencyConversion", params)

//获取home虚拟提现数据
const virtualWithdraw = (params) => axios.post("/system/virtualWithdraw", params)

//获取home虚拟提现数据
const contactsUs = (params) => axios.post("/system/contactsUs", params)


export default {
    testApi,
    getSystemBasicsInfo,
    emailCodeSend,
    emailRegister,
    emailLogin,
    resetPwd,
    resetPayPwd,
    resetLoginPwd,
    logout,
    bannerList,
    getUserInfo,
    getUserStatistics,
    depositLog,
    withdrawLog,
    paymentList,
    transactionsLog,
    orderList,
    orderDetail,
    referralsLog,
    frontModuleList,
    productsList,
    productDetail,
    productsBuy,
    articlesList,
    articlesDetail,
    langList,
    userRecharge,
    userRechargeUpload,
    userRechargeDetail,
    withdrawalMethodList,
    userWithdraw,
    inviteList,
    getFeedbackList,
    setFeedback,
    getFeedbackDetail,
    googleAuth,
    verifyGoogleAuthCode,
    setWithdrawAddress,
    currencyConversion,
    virtualWithdraw,
    contactsUs,
    forgetPwd
}
